import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex h-full min-h-0 w-full flex-1 flex-col gap-1.5 overflow-auto py-1.5" }

import AppLayout from '@/layouts/AppLayout.vue';
    import { type AuthUser, type BreadcrumbItem } from '@/types';
    import { Head } from '@inertiajs/vue3';
    import ProfileInformationForm from '@/components/ProfileInformationForm.vue';
    import ProfilePasswordForm from '@/components/ProfilePasswordForm.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Profile',
  props: {
    user: {}
  },
  setup(__props: any) {

    const props = __props;

    const breadcrumbs: BreadcrumbItem[] = [
        {
            title: 'profile.profile_settings',
            href: route('v2.profile.index'),
        },
    ];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Head), {
      title: _ctx.$t('profile.profile_settings')
    }, null, 8, ["title"]),
    _createVNode(AppLayout, { breadcrumbs: breadcrumbs }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(ProfileInformationForm, { user: _ctx.user }, null, 8, ["user"]),
          _createVNode(ProfilePasswordForm)
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})